import {ApplicationStatus} from "profile/enums";
import {imageBaseUrl} from "config";

export enum ENV {
    UAT = "UAT",
}

export enum EVENT_NAMES {
    PROFILE_UPDATE = "PROFILE_UPDATE",
    BUY_EGOLD = "eGold Buy Gold",
    EGOLD_PAY = "eGold Proceed to Pay",
    EGOLD_CHECKOUT = "eGold Checkout",
    EGOLD_SOLD = "eGold Sell Gold Confirmed",
    EGOLD_SELL_GOLD = "eGold Sell Gold",
}

export const statusMessages = {
    [ApplicationStatus.INCOMPLETE_INFO]: {
        heading: "ADDITIONAL INFORMATION REQUIRED",
        desc: "Please provide the additional information to process your loan application",
        iconUrl: `${imageBaseUrl}/img/ic_application_in_progress.svg`,
        buttonText: "View Details"
    }
}